(function () {
    let console_error = window.console.error.bind(window.console);
    let console_log = window.console.log.bind(window.console);
    let console_warn = window.console.warn.bind(window.console);

    function Log() {
       this.init();
    }

    Log.prototype = {

        init() {
            /**
             * Catch system error to send to Crashlytics
             * @param errorMsg
             * @param url
             * @param line
             * @param col
             * @param error
             */
            window.onerror = (errorMsg, url, line, col, error) => {
                this.showError(error, false);
            }


            let _this = this;
            // Override console.log to set logMessage for Crashlytics

            console.log = function () {
                _this.log.apply(this, arguments);

                _this.logMessage(arguments);
            }


            console.error = function () {
                if (arguments && arguments.length === 1 && arguments[0] instanceof Error) {
                    _this.showError(arguments[0], true);
                } else {
                    let message = _this.toString(arguments);
                    let error = new Error(message);
                    _this.showError(error, true);
                }
            }
            console.warn = function (message) {
                if (message.indexOf("ARIA") === -1) {
                    _this.warn.apply(this, arguments);
                }
            }
        },
        error() {
            if (config && config.environment === 'dev') {
                console_error.apply(console, arguments);
            }
        },
        log() {
            // Return original console log with original stack trace
            if (config && config.environment === 'dev') {
                console_log.apply(console, arguments);
            }
        },
        warn() {
            // Return original console log with original stack trace
            if (config && config.environment === 'dev') {
                console_warn.apply(console, arguments);
            }
        },
        toString(args) {
            let message = "";
            let params = [];
            for (let i = 0; i < args.length; i++) {
                params.push(this.convert(args[i]));
            }
            message = params.join(" ");
            return message;
        },
        convert(value) {
            if (typeof value === 'object') {
                try {
                    return JSON.stringify(value);
                } catch (e) {
                    return "[object]";
                }
            } else {
                return value;
            }
        },
        /**
         *
         * @param args
         */
        logMessage(args) {
            let message = typeof args === 'object' ? this.toString(args) : args;
            if(window.FirebasePlugin){
                FirebasePlugin.logMessage(message);
            }
        },
        /**
         * @param message{string}
         * @param trace{any[]|null}
         */
        setError(message, trace) {
            this.error(message, trace);
            if(window.FirebasePlugin){
                FirebasePlugin.logError(message, trace);
            }
        },
        /**
         * Sends a non-fatal error event to Crashlytics. In a Cordova app, you may use this to log unhandled Javascript exceptions
         * @param error{Error}
         */
        logError(error) {
            StackTrace.fromError(error).then((frames) => {
                frames = frames.filter((frame)=>{
                    let fileName = frame.fileName;
                    return !['log.js'].find((exclude)=>{
                        return fileName.indexOf(exclude)!==-1;
                    });
                    // return true;
                });
                this.setError(error.message, frames);
            }, () => {
                this.setError(error.message, null);
            });
        },
        /**
         *
         * @param error{Error}
         * @param showError{boolean}
         */
        showError(error, showError) {
            // call super (console.error)
            if (showError) {
                this.error(error.stack);
            }

            // logMessage for Crash
            this.logMessage(error.stack);

            // logError for Crash
            this.logError(error);

        }
    }
    if (window.cordova) { // cordova
        window.log = new Log(); // Init log when app is ready
    } else { 
        if(config.environment === 'prod'){ // browser and production
            // Don't show  console, warn if run on browser and production
            console.log = () => {
            };
            console.warn = () => {
            };
        }
    }
})();
